import { getTemplate } from "../template-helper";
import { getFieldAndBindPath } from "../../util/schema-helper";
import { tr } from "../../util/locales";
import { uuidv4 } from "../../util/utils";

const COMPONENT_NAME = "z-radio" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class RadioComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.init() ;
            }


            init(){
                if(!this.divContainer){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
    
                    this.currentModel = this.getAttribute("z-model");
                    let field = null;
                    if(this.currentModel[0] === "{"){
                        field = JSON.parse(this.currentModel) ;
                    }else{
                        let fieldDef = getFieldAndBindPath(this.currentModel, this.getAttribute("z-app")) ;
                        field = fieldDef.field ;
                    }
    
                    this.divContainer = this.querySelector(".z-radio-container") ;
                    this.divContainer.innerHTML = "" ;
                    this.inputValue = this.querySelector(".radio-hidden-input") ;
    
                    this.currentValue = null ;
    
                    this.name = uuidv4() ;
    
                    if(Array.isArray(field.values)){
                        for(let val of field.values){
                            const trKey = "values."+this.currentModel+"."+val ;
                            const valTranslated = tr(trKey) ;
                            let radioLabel = "" ;
                            if(valTranslated !== trKey){
                                radioLabel = valTranslated;
                            }else{
                                radioLabel = val;
                            }
                            this.createOneRadio(val, radioLabel) ;
                        }
                    }else if(field.values){
                        (field.valuesKeys||Object.keys(field.values)).forEach((v)=>{
                            let radioLabel = field.values[v];

                            if(this.currentModel[0]!=="{"){
                                const trKey = "values."+this.currentModel+"."+v ;
                                const valTranslated = window.tr(trKey) ;
                                if(valTranslated !== trKey){
                                    radioLabel = valTranslated;
                                }
                            }
                            this.createOneRadio(v, radioLabel) ;
                        }) ;
                    }
    
                    this.value = this.currentValue ;
                }
                this.applyReadonly() ;
                this.applyRequired() ;

            }

            createOneRadio(value, radioLabel){
                const div = document.createElement("div") ;
                div.className = "form-check form-check-inline" ;
                const input = document.createElement("input") ;
                input.type = "radio" ;
                input.name = "_"+this.name ;
                input.id = "_"+this.name+"_"+ value;
                input.value = value;
                input.className = "form-check-input";
                const label = document.createElement("label") ;
                label.className = "form-check-label";
                label.setAttribute("for", "_"+this.name+"_"+ value);
                label.innerHTML = radioLabel;

                input.addEventListener("change", ()=>{
                    this.currentValue = value ;
                    this.inputValue.value = value ;
                }) ;

                div.appendChild(input);
                div.appendChild(label);
                this.divContainer.appendChild(div) ;
            }

            get required() {
                return this.hasAttribute("required") ;
            }
            
            set required(required) {
                if(required){
                    this.setAttribute('required', required);
                }else{
                    this.removeAttribute('required');
                }
            }

            get readonly() {
                return this.hasAttribute("readonly") ;
            }
            
            set readonly(readonly) {
                if(readonly){
                    this.setAttribute('readonly', readonly);
                }else{
                    this.removeAttribute('readonly');
                }
            }

            get value() {
                return this.currentValue;
            }
            
            set value(value) {
                if(value === true){
                    value = "true" ;
                }
                if(value === false){
                    value = "false" ;
                }
                this.currentValue = value ;
                if(this.inputValue){
                    this.inputValue.value = value ;
                }
                const radios = this.querySelectorAll('input[type="radio"]') ;
                for(let radio of radios){
                    radio.checked = radio.value == value ;
                }
            }

            static get observedAttributes() {
                return ['readonly', "required"];
            }

            applyReadonly(){
                const radios = this.querySelectorAll('input[type="radio"]') ;
                for(let radio of radios){
                    radio.disabled = this.readonly ;
                }
            }

            applyRequired(){
                const required = this.hasAttribute("required") ;
                if(this.inputValue){
                    if(required){
                        this.inputValue.setAttribute("required", "required") ;
                    }else{
                        this.inputValue.removeAttribute("required") ;
                    }
                }
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'required':
                        this.applyRequired();
                        break;
                    case 'readonly':
                        this.applyReadonly() ;
                        break;
                }
            }
        }
        customElements.define(COMPONENT_NAME, RadioComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
